module.exports = __webpack_public_path__ + "static/media/satisfaction-survey.1d37338e.jpg";